import React from 'react';
import { cn } from '../../utils/cn';
import AppLogo from './AppLogo';

const sizeClassName = {
  xs: 'h-6 w-6',
  sm: 'h-10 w-10',
  md: 'h-14 w-14',
};

/** Pulsing product mark for page, list, and overlay loading states. */
const LoadingMark = ({
  size = 'sm',
  message,
  className,
  messageClassName,
}) => {
  return (
    <div className={cn('flex flex-col items-center gap-3', className)}>
      <AppLogo
        size="sm"
        variant="mark"
        className={cn(sizeClassName[size] || sizeClassName.sm, 'animate-pulse')}
      />
      {message ? (
        <p className={cn('text-sm text-muted-foreground', messageClassName)}>
          {message}
        </p>
      ) : null}
    </div>
  );
};

export default LoadingMark;
